<template>
  <div class="flex flex-col items-center px-8 pt-6 pb-12 mx-auto w-full sm:w-4/5 md:px-8 md:w-2/3">
    <div class="flex justify-between items-center py-8 w-full md:py-14">
      <div>
        SMS
      </div>

      <div class="flex gap-4">
        <NuxtLink
          v-if="authenticated"
          to="/portal"
        >
          <UButton
            label="Portal"
            size="md"
          />
        </NuxtLink>
        <NuxtLink
          v-if="!authenticated && !(route.path.startsWith('/auth/login'))"
          to="/auth/register"
        >
          <UButton
            label="Register"
            outlined
            size="md"
          />
        </NuxtLink>
        <NuxtLink
          v-if="!authenticated && !(route.path.startsWith('/auth/login'))"
          to="/auth/login"
        >
          <UButton
            label="Login"
            size="md"
          />
        </NuxtLink>
      </div>
    </div>

    <div class="w-full">
      <NuxtPage />
    </div>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()

const user = useUserStore()

const authenticated = ref(false)
onMounted(async () => {
  authenticated.value = await user.isAuthenticated()
})
</script>
